import { useMemo } from 'react';
import { Select } from 'antd';
import { observer } from 'mobx-react-lite';

import { TTerminalType } from '../../core/terminal';

type UiSelectTerminalTypeProps = {
  items?: TTerminalType[];
  value?: TTerminalType;
  loading?: boolean;
  onChange: (value: TTerminalType) => void;
};

const defaultValue: TTerminalType = {
  id: 0,
  name: '',
};

const defaultItems: TTerminalType[] = [];

export const UiSelectTerminalType = observer(
  ({
    items = defaultItems,
    value = defaultValue,
    loading = false,
    onChange,
  }: UiSelectTerminalTypeProps) => {
    const selectValue = useMemo(() => {
      return items.length === 0 ? '' : String(value.id || '');
    }, [items.length, value.id]);

    const handleChange = (value: string) => {
      const foundItem = items.find((item) => Number(item.id) === Number(value));
      if (!foundItem) return;

      onChange(foundItem);
    };

    return (
      <Select
        loading={loading}
        value={selectValue}
        onChange={handleChange}
        style={{ width: '100%' }}
        placeholder="Выберите тип терминала"
      >
        {items.map((item) => (
          <Select.Option key={String(item.id)} value={String(item.id)}>
            {item.name}
          </Select.Option>
        ))}
      </Select>
    );
  }
);
